/* eslint-disable angular/file-name */
angular.module('zc.commonApi')

  .factory('ZcsCampaignStats', ZcsCampaignStats);

ZcsCampaignStats.$inject = ['$q', 'FacadeV2'];
function ZcsCampaignStats($q, FacadeV2) {
  const service = {
    find
  };

  return service;

  function find(paths = {}, query = {}, options = {}) {
    return $q((resolve, reject) => {
      if(!paths.apikey) {
        const errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if(!paths.dimension) {
        const errorMsg = 'No dimension';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      const promise = FacadeV2.request(`/apikeys/${paths.apikey}/zcs_campaign_stats/${paths.dimension}/find`, {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(res => {
        if(res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching zcs campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/zcs_campaign_stats.service.js